import {
  CaretDownOutlined,
  CloseOutlined,
  LoadingOutlined,
  LogoutOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import { array } from '@dimjs/utils';
import { fbaHooks, Gap } from '@flatbiz/antd';
import {
  arrayFindByLoosely,
  TAny,
  toLinkPath,
  TPlainObject,
  treeToArray,
  valueIsEqual,
} from '@flatbiz/utils';
import { hooks } from '@wove/react';
import { Badge, Dropdown, MenuProps, Result, Tabs, TabsProps } from 'antd';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { DevFloatHelp } from '../../compts/dev-float-help';
import { Loader } from '../../compts/loader';
import { useLayoutCtx } from '../../context/layout-ctx';
import { IframePage } from './iframe-page';
import './style.less';
/**
 * 此处如果存在面包屑/tabbar路由菜单, 需要处理layout/flex布局问题
 * @param props
 */
const PageContent = () => {
  const {
    iframeTabList,
    // hideHeader,
    iframeTabBarExtra,
    iframeTabActiveItem,
    onIframeChange,
    onDeleteIframeTabItemAndSetActive,
    siderBarTileMenus,
    redDotMap,
    onChangeActiveTabItemRedDot,
    developmentEnvGuideConfigs,
    showProdEnvGuide,
    // headerHeight,
  } = useLayoutCtx();
  const [iframeLoadKeyList, setIframeLoadKeyList] = useState<string[]>([]);

  const [refreshIframeIds, setRefreshIframeIds] = useState<Array<string | number>>([]);

  const refreshIframeStart = hooks.useCallbackRef((tabItem) => {
    refreshIframeIds.push(tabItem.id);
    setRefreshIframeIds([...refreshIframeIds]);
  });

  const refreshIframeStartEnd = hooks.useCallbackRef((tabItem) => {
    const newArray = array.arrayRemove(refreshIframeIds, tabItem.id);
    setRefreshIframeIds([...newArray]);
  });

  fbaHooks.useEffectCustom(() => {
    if (iframeTabActiveItem?.id) {
      window[`__refresh_iframe_${iframeTabActiveItem.id}`] = {
        start: () => {
          refreshIframeStart(iframeTabActiveItem);
        },
        end: refreshIframeStartEnd.bind(null, iframeTabActiveItem),
      };
    }
  }, [iframeTabActiveItem?.id]);

  const onTabClick = hooks.useDebounceClick((key: string) => {
    if (key === iframeTabActiveItem?.id && redDotMap[iframeTabActiveItem?.id || '']) {
      onChangeActiveTabItemRedDot(false);
    }
    onIframeChange(key, 'iframeTabClick');
  }, 200);

  const onTabItemRemove = hooks.useCallbackRef((tabItemKey) => {
    if (valueIsEqual(tabItemKey, iframeTabActiveItem.id)) {
      onDeleteIframeTabItemAndSetActive('me', tabItemKey as string);
    } else {
      onDeleteIframeTabItemAndSetActive('other', tabItemKey as string);
    }
  });

  const onClick = hooks.useCallbackRef((data) => {
    if (data.key === '1') {
      onIframeChange(iframeTabActiveItem.id as string, 'iframeRefresh');
    } else if (data.key === '2') {
      onDeleteIframeTabItemAndSetActive('otherAll');
    } else if (data.key === '3') {
      onDeleteIframeTabItemAndSetActive('all');
    }
  });

  const menuItems: MenuProps['items'] = [
    {
      label: '刷新当前',
      key: '1',
      onClick: onClick.bind(null, { key: '1' }),
      icon: <RedoOutlined />,
    },
    {
      label: '关闭其他',
      key: '2',
      onClick: onClick.bind(null, { key: '2' }),
      icon: <CloseOutlined />,
    },
    {
      label: '关闭所有',
      key: '3',
      onClick: onClick.bind(null, { key: '3' }),
      icon: <LogoutOutlined />,
    },
  ];

  const tabItems: TabsProps['items'] = iframeTabList.map((item) => {
    const pageSpinner = !arrayFindByLoosely(iframeLoadKeyList, item.iframeKey);
    let menuKey: undefined | string;
    if (item.menuId) {
      menuKey = siderBarTileMenus.find((temp) => valueIsEqual(temp.id, item.menuId))?.key;
    }
    // const fixHeight = hideHeader ? 38 : 38 + (headerHeight as number);
    return {
      label: redDotMap[item.id] ? (
        <span style={{ position: 'relative' }}>
          <Badge dot className="iframe-tabs-tab-badge"></Badge>
          {item.name}
        </span>
      ) : (
        item.name
      ),
      key: `${item.id}`,
      style: {
        height: '100%',
        position: 'relative',
      },
      closable: true,
      closeIcon: arrayFindByLoosely(refreshIframeIds, item.id) ? (
        <LoadingOutlined />
      ) : (
        <span className="tab-icon"></span>
      ),
      children: (
        <Fragment>
          <Loader spinning={pageSpinner} style={{ backgroundColor: 'var(--bg-color)' }} />
          <IframePage
            id={item.id as string}
            link={item.link}
            iframeKey={item.iframeKey}
            onLoad={function (): void {
              const target = document.querySelector(`#iframe_${item.id}`) as HTMLIFrameElement;
              try {
                if (target.contentWindow) {
                  target.contentWindow['__iframe_node_key'] = `iframe_${item.id}`;
                  target.contentWindow['__iframe_node'] = item;
                }
              } catch (_error) {
                // 异常不处理，iframe写入属性可能会存在跨域问题
              }
              setIframeLoadKeyList((prev) => {
                return prev.concat(item.iframeKey);
              });
            }}
            menuKey={menuKey}
          />
        </Fragment>
      ),
    };
  });

  return (
    <Fragment>
      <Tabs
        hideAdd={true}
        items={tabItems}
        activeKey={iframeTabActiveItem?.id as string}
        onTabClick={onTabClick}
        // onChange={onTabChange}
        style={{ height: '100%' }}
        className="iframe-tabs"
        type={iframeTabList.length === 1 ? 'card' : 'editable-card'}
        onEdit={onTabItemRemove}
        tabBarExtraContent={{
          right: iframeTabBarExtra ? (
            iframeTabBarExtra
          ) : (
            <Dropdown
              menu={{ items: menuItems }}
              arrow={true}
              className="menu-tabs-operate"
              placement="bottomRight"
              overlayClassName="menu-tabs-operate-dropdown"
              // 此处不能使用 click
              trigger={['hover']}
            >
              <CaretDownOutlined />
            </Dropdown>
          ),
        }}
      />
      <DevFloatHelp
        developmentEnvGuideConfigs={developmentEnvGuideConfigs}
        showProdEnvGuide={showProdEnvGuide}
      />
    </Fragment>
  );
};

const PageContentSingleFrame = () => {
  const ctx = useLayoutCtx();
  const actived = ctx.iframeTabActiveItem;
  const [iframeLoadKeyList, setIframeLoadKeyList] = useState<string[]>([]);
  const pageSpinner = !arrayFindByLoosely(iframeLoadKeyList, actived?.iframeKey);
  return (
    <div style={{ flex: 1, position: 'relative' }}>
      <Loader spinning={pageSpinner} style={{ backgroundColor: 'var(--bg-color)' }} />
      <iframe
        id={`iframe_${String(actived?.id)}`}
        src={actived?.link}
        width="100%"
        height="100%"
        key={actived?.iframeKey}
        style={{ border: 'none' }}
        onLoad={() => {
          setIframeLoadKeyList((prev) => {
            return prev.concat(actived?.iframeKey);
          });
        }}
      />
      <DevFloatHelp
        developmentEnvGuideConfigs={ctx.developmentEnvGuideConfigs}
        showProdEnvGuide={ctx.showProdEnvGuide}
      />
    </div>
  );
};

export const PageLevelContent = () => {
  const ctx = useLayoutCtx();

  const [activeItem, setActiveItem] = useState<TPlainObject>();

  const targetList = useMemo(() => {
    const targetList = treeToArray(ctx.completeMenus, 'children').find((item) =>
      valueIsEqual(item.id, ctx.siderBarMenuActiveItem?.id),
    )?.children as TPlainObject[];
    return targetList || [ctx.siderBarMenuActiveItem];
  }, [ctx.completeMenus, ctx.siderBarMenuActiveItem]);

  const items: TabsProps['items'] = useMemo(() => {
    return targetList?.map((item) => {
      return {
        key: `${item.id}`,
        label: item.name,
        children: <Fragment />,
      };
    });
  }, [targetList]);

  useEffect(() => {
    setActiveItem({ ...targetList[0], id: `${targetList[0]?.id}` });
  }, [targetList]);

  const onTabClick = (activeKey: string) => {
    if (valueIsEqual(activeKey, activeItem?.id)) {
      const frameInstance = document.querySelector(`#content_topmenu_${activeKey}`);
      setActiveItem({
        ...activeItem,
        key: Date.now(),
        link: toLinkPath(frameInstance?.['contentWindow']?.location?.href || activeItem?.link),
      });
      return;
    }
    const target = targetList.find((item) => valueIsEqual(item.id, activeKey));
    setActiveItem({ ...target, id: `${target?.id}` });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {items.length > 1 ? (
        <Tabs
          tabBarStyle={{ margin: 0 }}
          onTabClick={onTabClick}
          defaultActiveKey="1"
          activeKey={activeItem?.id}
          items={items}
          type="card"
          className="content-top-menus"
        />
      ) : null}

      <iframe
        id={`content_topmenu_${activeItem?.id}`}
        src={activeItem?.link}
        width="100%"
        height="100%"
        key={activeItem?.key}
        style={{ border: 'none', flex: 1 }}
      />
    </div>
  );
};

export const LayoutIFrame = () => {
  const layoutCtx = useLayoutCtx();
  const [renderStatus, setRenderStatus] = useState<'init' | 'yes' | 'error'>('init');
  const [errorData, setErrorData] = useState<TAny>();

  const iframeTabRenderPreHook = layoutCtx.iframeTabRenderPreHook;

  fbaHooks.useEffectCustomAsync(async () => {
    try {
      if (iframeTabRenderPreHook?.execute) {
        await iframeTabRenderPreHook?.execute();
      }
      setRenderStatus('yes');
    } catch (error) {
      setRenderStatus('error');
      setErrorData(error);
    }
  }, []);

  if (renderStatus === 'init') {
    return (
      <div
        className="iframe-tab-render-pre-hook"
        style={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Gap height={38} />
        <div style={{ position: 'relative', flex: 1 }}>
          <Loader spinning={true} style={{ backgroundColor: 'var(--bg-color)' }} />
        </div>
      </div>
    );
  }
  if (renderStatus === 'error') {
    return (
      <div
        className="iframe-tab-render-pre-hook"
        style={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {iframeTabRenderPreHook?.errorRender ? (
          iframeTabRenderPreHook?.errorRender(errorData)
        ) : (
          <Result
            style={{
              backgroundColor: '#fff',
              width: 500,
              margin: '0 auto',
              borderRadius: 10,
              boxShadow: '0 0 20px rgba(0, 0, 0, 0.01)',
              transform: 'translateY(-20%)',
            }}
            status="error"
            title={<span style={{ fontSize: 20 }}>页面渲染前置处理失败</span>}
            subTitle={errorData?.message}
          ></Result>
        )}
      </div>
    );
  }

  if (layoutCtx.multiFrameTabs) {
    return <PageContent />;
  }

  if (layoutCtx.siderBarMaxMenuLevel) {
    return <PageLevelContent />;
  }

  return <PageContentSingleFrame />;
};
